module.exports = __webpack_public_path__ + "static/royal-longsword-c08fae92c65a206352d5ef65f472c8fb.png";